export const GA_MEASUREMENT_ID = "G-CWEMEBY8JW";
export const GSHEET_SRIPT = "https://script.google.com/macros/s/AKfycbzq-m0rIooHzPahyS46QURA4xZ_5E4S4hNhzcSQ7iLqbCBSwLpnYhw_LWJ8vafkBQWq/exec";
export const GSHEET_SRIPT_BACKUP = "https://script.google.com/macros/s/AKfycbz1FIZPF83y6x9ndrqTCQbVvddUYuPvzx8kTVmVcOnExiv6Ch_wwAadiiIfZBlXRhwA/exec";
export const ORG_ID = "o-1WQRQM-na1";
export const PIXEL_ID = "621802908538307";
